module.exports = __webpack_public_path__ + "img/course_update.43833e95.svg";